const Social = () => {
  return (
    <div className='home__social'>
      <a href="https://www.instagram.com/motez_halleb/" className="home__social-icon" target='_blank' rel="noreferrer">
        <i className="uil uil-instagram"></i>
      </a>
      <a href="https://www.linkedin.com/in/motez-halleb-2677402b6/" className="home__social-icon" target='_blank' rel="noreferrer">
      <i className="uil uil-linkedin"></i>
      </a>
      <a href="https://github.com/moteaz" className="home__social-icon" target='_blank' rel="noreferrer">
      <i className="uil uil-github-alt"></i>
      </a>
    </div>
  )
}

export default Social
